module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/alerts/createalert.component.scss
// module id = 344
// module chunks = 1